<template>
  <div class="SucheRunde" slot="activator" v-if="user">

    <h3>Suche Runde</h3>

    <v-layout>
      <v-flex xs12>
        
        <v-card v-if="year != null">
          <v-card-title primary-title class="pt-2 pb-0">
            <h4 class="mb-1">Bitte Jahr auswählen</h4>
          </v-card-title>
          <v-card-text class="pt-0 pb-0">
            <v-select v-bind:items="years" v-model="selectedYear" label="Jahr auswählen" single-line bottom></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="blue--text darken-1" flat="flat" @click.native="setYear">Auswählen</v-btn>
          </v-card-actions>
        </v-card>
        <br>

        <v-layout>
          <v-flex xs12 class="text-xs-center">
            <v-progress-circular indeterminate class="warning--text" :width="7" :size="70" v-if="loading"></v-progress-circular>
          </v-flex>
        </v-layout>

        <v-card v-if="searchRounds != null && !loading">
          <v-card-title primary-title class="pb-0">
            <h4 class="mb-1">Zum Löschen antippen</h4>
          </v-card-title>
          <table>
            <thead>
              <tr>
                <th style="width: 40%">Datum</th>
                <th class="tableData">Kurs</th>
                <th class="tableData">Punkte</th>
                <th class="tableData">Schläge</th>
              </tr>
            </thead>
            <tbody v-for="(round, index) in searchRounds" :key="index">
              <tr @click.stop="openDialog(round.val().roundKey, round.key, index)" class="editRow">
                <td>{{ round.val().datum }}</td>
                <td>{{ round.val().farbe }}</td>
                <td>{{ round.val().points }}</td>
                <td>{{ round.val().score }}</td>
              </tr>
            </tbody>
          </table>
        </v-card>

      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" lazy absolute>
      <v-card>
        <v-card-title>
          <div class="headline">Runde löschen?</div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="red--text darken-1" flat="flat" @click.native="dialog = false">Abbrechen</v-btn>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="deleteRound">Löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
export default {
  name: 'SucheRunde',

  data() {
    return {
      selectedYear: null,
      dialog: false,
      roundKey: null,
      shortKey: null,
      index: null
    }
    // End Data
  },

  computed: {
    user() {
      return this.$store.getters.user
    },
    year() {
      return Number(this.$store.getters.year)
    },
    years() {
      if (this.year != null) {
        var years = []
        years.push(this.year, this.year - 1, this.year - 2)
        return years
      }
    },
    searchRounds() {
      return this.$store.getters.searchRounds
    },
    loading() {
      return this.$store.getters.loading
    }

    // End Computed
  },
  beforeDestroy() {
    this.$store.dispatch('deleteSearchRounds')
  },

  methods: {
    setYear() {
      this.$store.dispatch('searchRounds', { year: this.selectedYear })
    },
    openDialog(x, y, index) {
      this.dialog = true
      this.roundKey = x
      this.shortKey = y
      this.index = index
    },
    deleteRound() {
      var z = this.selectedYear
      this.$store.dispatch('deleteRounds', { roundKey: this.roundKey, shortKey: this.shortKey, year: z })
      this.searchRounds.splice(this.index, 1)
      this.dialog = false
    }
    // End Methods
  }
}
</script>

<style scoped>
@media (max-width: 667px) {

  .container {
    padding: 5px;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

td {
  text-align: center;
}

.tableData {
  width: 20%;
}

tr {
  height: 4em;
  border-bottom: 1px solid #d0d0d0;
}

.editRow:hover {
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, .2);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// SucheRunde.vue?fb25f278